export interface AdSlotPositionRule {
  firstPosition: number;
  repeatEvery?: number;
  hideWhenListLengthAtMost?: number;
}

//* 리스트 광고 슬롯 위치 판정. position은 1-based이며 호출부에서 `index + 1`로 넘긴다.
export const isAdSlotPosition = (
  position: number,
  listLength: number,
  {
    firstPosition,
    repeatEvery,
    hideWhenListLengthAtMost = 0,
  }: AdSlotPositionRule,
): boolean => {
  if (!Number.isInteger(position) || position < 1) return false;
  if (!Number.isInteger(listLength) || listLength < 0) return false;
  if (!Number.isInteger(firstPosition) || firstPosition < 1) return false;
  if (listLength <= hideWhenListLengthAtMost) return false;

  if (position === firstPosition) return true;
  if (repeatEvery === undefined) return false;
  if (repeatEvery <= 0) return false;
  if (position <= firstPosition) return false;

  return (position - firstPosition) % repeatEvery === 0;
};
